export default __webpack_public_path__ + "static/media/snowtree.7093d25d.png";